<template>
  <v-row justify="center">
    <v-dialog v-model="open" scrollable width="800px">
      <v-card>
        <v-row no-gutters>
          <v-col cols="7" class="pt-6 pl-6">
            <span class="modalTitle newTitle--text">{{
              $t('message.pages.folderSettings.addDomains')
            }}</span>
          </v-col>
          <v-col
            cols="5"
            :style="
              $vuetify.theme.dark ? '' : 'background-color: #EBEDFF !important'
            "
            style="height: 100%"
            class="pt-6 pr-6 pl-4"
          >
            <v-row no-gutters justify="space-between">
              <span class="modalSubtitle newTitle--text">{{
                $t('message.pages.folderSettings.howTo')
              }}</span>
              <v-icon style="cursor: pointer" @click="handleClose">
                mdi-close
              </v-icon>
            </v-row>
          </v-col>
        </v-row>
        <v-row no-gutters>
          <v-col cols="7" class="pl-6 pt-2">
            <v-row
              no-gutters
              style="overflow-y: auto; height: 400px; overflow-x: hidden"
            >
              <v-col cols="12">
                <v-row no-gutters>
                  <v-col cols="12" class="pb-6">
                    <span>{{
                      $t('message.pages.folderSettings.allownDomainsText')
                    }}</span>
                  </v-col>
                  <v-col
                    v-for="(domain, i) in writtenDomains"
                    cols="12"
                    :key="i"
                    class="pt-3 add-domain-input"
                  >
                    <v-row no-gutters :class="i !== 0 ? '' : 'pr-9'">
                      <v-text-field
                        v-model="domain.field"
                        class="pr-3"
                        outlined
                        dense
                        :label="$t('message.pages.folderSettings.writeDomain')"
                        :rules="[noCommaRule]"
                        @input="checkIfDomainIsVald(domain, i)"
                        :error="domain.regexpError || domain.already_exist"
                        :error-messages="domainErrorMessages(domain)"
                      >
                        <template #append-outer v-if="i !== 0">
                          <v-icon
                            color="error"
                            @click="removeFromWrittenDomains(i)"
                            style="cursor: pointer"
                          >
                            mdi-close-circle
                          </v-icon>
                        </template>
                      </v-text-field>
                    </v-row>
                  </v-col>
                  <v-col cols="12" class="mt-3">
                    <button @click="addAnotherDomain">
                      <span class="primary--text">
                        {{
                          $t('message.pages.folderSettings.addAnotherDomain')
                        }}
                      </span>
                    </button>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-col>
          <v-col
            cols="5"
            :style="
              $vuetify.theme.dark ? '' : 'background-color: #EBEDFF !important'
            "
            style="height: 100%"
            class="pt-3 pr-6 pl-4"
          >
            <v-row no-gutters>
              <p
                class="mb-1"
                v-html="$t('message.pages.folderSettings.helpTexts.line_1b')"
              />
              <ul class="my-3">
                <li>
                  <span
                    v-html="$t('message.pages.folderSettings.helpTexts.line_2')"
                  />
                </li>
                <li>
                  <span
                    v-html="$t('message.pages.folderSettings.helpTexts.line_3')"
                  />
                </li>
              </ul>
              <p
                class="mb-1"
                v-html="$t('message.pages.folderSettings.helpTexts.line_4')"
              />
              <ul class="my-3">
                <li>
                  <span
                    v-html="$t('message.pages.folderSettings.helpTexts.line_5')"
                  />
                </li>
                <li>
                  <span
                    v-html="$t('message.pages.folderSettings.helpTexts.line_6')"
                  />
                </li>
              </ul>
            </v-row>
          </v-col>
        </v-row>
        <v-row no-gutters>
          <v-col cols="7" class="py-6 pl-6">
            <v-btn
              class="mr-2"
              color="primary"
              elevation="0"
              :loading="isFetchingAdd"
              @click="handleAddRefer"
            >
              {{ $t('message.pages.folderSettings.saveDomains') }}
            </v-btn>
            <v-spacer />
          </v-col>
          <v-col
            cols="5"
            :style="
              $vuetify.theme.dark ? '' : 'background-color: #EBEDFF !important'
            "
            style="height: 100%"
          >
          </v-col>
        </v-row>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
// external imports
import { mapMutations } from 'vuex'
import referApi from '@/services/referApi.js'
import i18n from '@/translations/lang'

export default {
  name: 'AddDomains',
  props: ['userLibrary'],
  components: {},
  data: () => ({
    open: false,
    writtenDomains: [{ field: '', regexpError: false }],
    unknownErrorMsg: '',
    isFetchingAdd: false,
    refers: [],
    noCommaRule: (v) =>
      !v.includes(',') || i18n.t('message.pages.folderSettings.errors.invalidHostname'),
  }),
  computed: {
    domainErrorMessages() {
      return (domain) => {
        if (domain.regexpError) {
          return [
            this.$t('message.pages.folderSettings.errors.invalidHostname'),
          ]
        }
        if (domain.already_exist) {
          return [this.$t('message.pages.folderSettings.errors.alreadyExists')]
        }
        return []
      }
    },
  },
  async mounted() {
    this.$root.$on('openAddDomains', () => {
      Object.assign(this.$data, this.initialState())
      this.open = true
    })
    const getRefers = await referApi.getRefers(this.userLibrary.id)
    this.refers = getRefers.data.refers
  },
  watch: {},
  beforeDestroy() {
    this.$root.$off('openAddDomains')
  },
  methods: {
    ...mapMutations('user', ['UPDATE_FIRST_ACCESS']),
    checkIfDomainIsVald(domain, index) {
      this.writtenDomains[index].regexpError = false
      this.writtenDomains[index].already_exist = false
      let regex = new RegExp(
        '^[^,]*(([a-zA-Z0-9]|\\*\\.[a-zA-Z0-9])([a-zA-Z0-9-_]{0,243}[a-zA-Z0-9])?\\.)+[a-zA-Z]{2,50}$'
      )
      if (!regex.test(domain.field) && domain.field.length > 3) {
        this.writtenDomains[index].regexpError = true
        return
      }
    },
    async handleAddRefer() {
      this.unknownErrorMsg = ''
      let domains = []
      for (let domain of this.writtenDomains) {
        domain.field = domain.field.replace(/^(https?:\/\/|\*https?:\/\/)/, '')
        domains.push({
          hostname: domain.field,
          type: 'ALLOW',
        })
      }
      this.isFetchingAdd = true
      try {
        let ret = await referApi.addMultipleRefers(this.userLibrary.id, domains)
        this.$emit('addDomains', ret.data)
        this.handleClose()
      } catch (e) {
        this.isFetchingAdd = false
        if (e.response) {
          this.unknownErrorMsg = e.response.data.errMsg
          if (this.refers && this.unknownErrorMsg.includes('already exists')) {
            const domainExistent = JSON.parse(e.response.config.data)
            this.writtenDomains.forEach((domain) => {
              domain.field === domainExistent[0].hostname
                ? (domain['already_exist'] = true)
                : ''
            })
          }
        }
      }
      this.isFetchingAdd = false
    },
    addAnotherDomain() {
      this.writtenDomains.push({ field: '', regexpError: false })
    },
    removeFromWrittenDomains(index) {
      this.writtenDomains.splice(index, 1)
    },
    handleClose() {
      this.open = false
    },
    initialState() {
      return {
        open: false,
        writtenDomains: [{ field: '', regexpError: false }],
        unknownErrorMsg: '',
        refers: [],
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.modalTitle {
  font-size: 20px;
  font-weight: 500;
}
.modalSubtitle {
  font-size: 16px;
  font-weight: 500;
  line-height: 150%; /* 24px */
}
::v-deep .add-domain-input .v-label--active {
  padding: 0 5px;
  
  .theme--light & {
    background-color: #fff;
  }

  .theme--dark & {
    background-color: var(--v-neutral-darken2);
  }
}
</style>
